"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cardListFlyoutNormalizer = void 0;
const mock_json_1 = __importDefault(require("./mock.json"));
const normalizeFlyout = ({ data }) => {
    let res = {};
    try {
        const { fields } = data;
        const { title, price, unidad, prePrice, postPrice, img, featureList } = fields;
        if (title) {
            res["Text-1"] = Object.assign(Object.assign({}, mock_json_1.default["Card"]["FlyOut-1"]["Text-1"]), { text: title });
        }
        if (prePrice) {
            res["Text-3"] = Object.assign(Object.assign({}, mock_json_1.default["Card"]["FlyOut-1"]["Text-3"]), { text: prePrice });
        }
        if (postPrice) {
            res["Text-2"] = Object.assign(Object.assign({}, mock_json_1.default["Card"]["FlyOut-1"]["Text-2"]), { text: postPrice });
        }
        if (price) {
            res["Price-1"] = Object.assign(Object.assign({}, mock_json_1.default["Card"]["FlyOut-1"]["Price-1"]), { price: price, currency: unidad || '' });
        }
        if (img) {
            res["Image-1"] = Object.assign(Object.assign({}, mock_json_1.default["Card"]["FlyOut-1"]["Image-1"]), { src: img });
        }
        const newFeatures = [];
        if (featureList && Array.isArray(featureList) && featureList.length > 0) {
            featureList.map((feature, index) => {
                const auxFeature = {};
                const { fields } = feature;
                const { icon, subTitle, caracteristics } = fields;
                const newTexts = [];
                if (subTitle) {
                    auxFeature["Text-1"] = Object.assign(Object.assign({}, mock_json_1.default["Card"]["FlyOut-1"]["Features"]["Text-1"]), { text: subTitle });
                }
                if (icon) {
                    auxFeature["Icon-1"] = Object.assign(Object.assign({}, mock_json_1.default["Card"]["FlyOut-1"]["Features"]["Icon-1"]), { id: icon });
                }
                if (caracteristics && Array.isArray(caracteristics) && caracteristics.length > 0) {
                    caracteristics.map((carac, index) => {
                        newTexts.push(Object.assign(Object.assign({}, mock_json_1.default["Card"]["FlyOut-1"]["Features"]["Text-2"]), { text: carac }));
                    });
                    auxFeature.characs = newTexts;
                }
                newFeatures.push(auxFeature);
            });
            res["Characs-List"] = newFeatures;
        }
        return res;
    }
    catch (e) {
        console.error(error);
    }
    return res;
};
const cardListFlyoutNormalizer = (data) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    try {
        let res = {};
        const title = ((_a = data === null || data === void 0 ? void 0 : data.fields) === null || _a === void 0 ? void 0 : _a.title) || ((_c = (_b = data === null || data === void 0 ? void 0 : data[0]) === null || _b === void 0 ? void 0 : _b.fields) === null || _c === void 0 ? void 0 : _c.title);
        if (title) {
            res["Text-1"] = Object.assign(Object.assign({}, mock_json_1.default["Text-1"]), { text: title });
        }
        const href = ((_d = data === null || data === void 0 ? void 0 : data.fields) === null || _d === void 0 ? void 0 : _d.href) || ((_f = (_e = data === null || data === void 0 ? void 0 : data[0]) === null || _e === void 0 ? void 0 : _e.fields) === null || _f === void 0 ? void 0 : _f.href);
        if (href) {
            readSync.href = href;
        }
        const listCards = ((_g = data === null || data === void 0 ? void 0 : data.fields) === null || _g === void 0 ? void 0 : _g.listCards) || ((_j = (_h = data === null || data === void 0 ? void 0 : data[0]) === null || _h === void 0 ? void 0 : _h.fields) === null || _j === void 0 ? void 0 : _j.listCards);
        const newCards = [];
        if (listCards && Array.isArray(listCards) && listCards.length > 0) {
            listCards.map((card, index) => {
                const normalizedCard = {};
                const { fields } = card;
                const { title, description, prePrice, price, unityPrice, postPrice, btn, productFlyOut, link } = fields;
                if (title) {
                    normalizedCard["Text-1"] = Object.assign(Object.assign({}, mock_json_1.default["Card"]["Text-1"]), { text: title });
                }
                if (description) {
                    normalizedCard["Text-2"] = Object.assign(Object.assign({}, mock_json_1.default["Card"]["Text-2"]), { text: description });
                }
                if (prePrice) {
                    normalizedCard["Text-3"] = Object.assign(Object.assign({}, mock_json_1.default["Card"]["Text-3"]), { text: prePrice });
                }
                if (price) {
                    normalizedCard["Price-1"] = Object.assign(Object.assign({}, mock_json_1.default["Card"]["Price-1"]), { price: price, currency: unityPrice || '' });
                }
                if (postPrice) {
                    normalizedCard["Text-4"] = Object.assign(Object.assign({}, mock_json_1.default["Card"]["Text-4"]), { text: postPrice });
                }
                if (btn && btn.fields && btn.fields.label) {
                    normalizedCard["Button-1"] = Object.assign(Object.assign({}, mock_json_1.default["Card"]["Button-1"]), { href: btn.href, label: btn.fields.label });
                }
                if (link && link.href) {
                    normalizedCard["Link-1"] = link;
                }
                if (productFlyOut) {
                    normalizedCard["FlyOut-1"] = normalizeFlyout(productFlyOut);
                }
                newCards.push(normalizedCard);
            });
            res.cards = newCards;
        }
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.cardListFlyoutNormalizer = cardListFlyoutNormalizer;
exports.default = exports.cardListFlyoutNormalizer;
//# sourceMappingURL=index.js.map